import workspaceQuery from '../../../graphql/queries/company/OptionalMandatoryFieldsWorkspace.graphql';
import listQuery from '../../../graphql/queries/company/OptionalMandatoryFieldsListQuery.graphql';
import instanceQuery from '../../../graphql/queries/company/OptionalMandatoryFieldsQuery.graphql';
import defaultQuery from '../../../graphql/queries/company/OptionalMandatoryFieldsDefault.graphql';
import mutationQuery from '../../../graphql/mutations/company/OptionalMandatoryFieldsMutationQuery.graphql';
import fragment from '../../../graphql/fragments/company/OptionalMandatoryFieldsFragment.graphql';
import { ALLOW_EDIT, ALLOW_VIEW } from '../../../utils/OperationPermissions';

const OptionalMandatoryFields = {
  type: 'OptionalMandatoryFields',
  title: 'Optional Mandatory Fields',
  formTitle: 'Optional Mandatory Fields',
  formUrl: '/Company/OptionalMandatoryFields/Details/',
  workspaceUrl: '/Company/OptionalMandatoryFields/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'description',
  },
  fragment,
  screenReference: 'MANDATORY_FIELDS',
  operations: ALLOW_EDIT | ALLOW_VIEW,
};

export default OptionalMandatoryFields;
